import type { MemberPreferredCommunicationChannel } from "@albertine/types";

export const PREFERRED_CHANNEL_LABELS: Record<
    MemberPreferredCommunicationChannel,
    string
> = {
    app: "App",
    whatsapp: "WhatsApp",
    email: "Email",
    "phone-call": "Phone call",
};
